import { render } from "./TranscribeButton.vue?vue&type=template&id=2b8a7ed6&scoped=true"
import script from "./TranscribeButton.vue?vue&type=script&lang=js"
export * from "./TranscribeButton.vue?vue&type=script&lang=js"

import "./TranscribeButton.vue?vue&type=style&index=0&id=2b8a7ed6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8a7ed6"]])

export default __exports__